const AUTH_GETTERS = {
  isAuthorized: 'auth/isAuthorized',
  preferredFiat: 'auth/preferredFiat',
}

export { AUTH_GETTERS }
